// Angular dependencies
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppRouterModule } from './app.router';

// Import vendor modules
import { NgxPopperModule } from 'ngx-popper';

// Share component
import { CoreModule } from './core.module';

// Store
import { AppStoreModule } from './store.module';

// Pages
import { PageMainModule } from './page-main.module';
import { PageCreepModule } from './page-creep.module';
import { PageCreepLevelModule } from './page-creep-level.module';

import { AppComponent } from './app.component';

import { SkillTooltipDirective } from './skill-tooltip.directive';


@NgModule({
  imports: [
    // Native modules
    FormsModule,
    BrowserModule,
    RouterModule,

    // Vendors
    NgxPopperModule.forRoot({
       disableDefaultStyling: true,
       placement: 'bottom'
    }),

    // Store
    AppStoreModule,

    // Page router
    AppRouterModule,

    // Shares' components
    CoreModule,

    // Pages' modules
    PageMainModule,
    PageCreepModule,
    PageCreepLevelModule
  ],

  declarations: [
    AppComponent,
    SkillTooltipDirective,
  ],

  providers: [],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/app.module.ts